var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ring-item"},[_c('div',{staticClass:"ring-item-warp"},[_c('el-progress',{attrs:{"type":"dashboard","percentage":_vm.percentage,"stroke-width":_vm.strokeWidth,"color":_vm.colors,"text-inside":true}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }